import React, { createContext, useState, useContext } from 'react';

const LangContext = createContext();

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    // Default language should be English
    return localStorage.getItem('appLang') || 'en';
  });

  const toggleLang = () => {
    const newLang = lang === 'de' ? 'en' : 'de';
    setLang(newLang);
    localStorage.setItem('appLang', newLang);
  };

  return (
    <LangContext.Provider value={{ lang, setLang, toggleLang }}>
      {children}
    </LangContext.Provider>
  );
};

export const useLang = () => {
  const context = useContext(LangContext);
  if (!context) {
    throw new Error('useLang must be used within LangProvider');
  }
  return context;
};
